// extracted by mini-css-extract-plugin
module.exports = {"typography":"styles_typography__NCQ7Z"};